import { EmailShareTemplate } from "../templates/EmailShareTemplate";
import { FacebookShareTemplate } from "../templates/FacebookShareTemplate";
import { LinkedinShareTemplate } from "../templates/LinkedinShareTemplate";
import { TwitterShareTemplate } from "../templates/TwitterShareTemplate";
import { WhatsappShareTemplate } from "../templates/WhatsappShareTemplate";

export const shareButtonTemplatesEnum = {
  facebook: (pageTitle, pageUrl) => FacebookShareTemplate({ pageTitle, pageUrl }),
  twitter: (pageTitle, pageUrl) => TwitterShareTemplate({ pageTitle, pageUrl }),
  linkedin: (pageTitle, pageUrl) => LinkedinShareTemplate({ pageTitle, pageUrl }),
  whatsapp: (pageTitle, pageUrl) => WhatsappShareTemplate({ pageTitle, pageUrl }),
  email: (pageTitle, pageUrl, body) => EmailShareTemplate({ pageTitle, pageUrl, body }),
};
